import { Box } from '@mui/material'
import Crown from '../../../../../assets/icons/crown.svg?react'

type IProps = {
    winner?: boolean
    children?: React.ReactNode
}

export const GameOverColumnContent = ({ winner, children }: IProps) => {
    return (
        <Box
            sx={{
                position: 'relative',
                height: '100%',
            }}
        >
            {winner && (
                <Box
                    sx={(theme) => ({
                        height: { xs: '24px', md: '40px' },
                        position: 'absolute',
                        zIndex: 3,
                        left: { xs: '-15%', md: '-15%' },
                        top: { xs: '-15%', md: '-16%' },
                        transform: 'rotate(-45deg)',
                        display: 'flex',
                        justifyContent: 'center',
                        svg: { fill: theme.palette.secondary.main, height: { xs: '24px', md: '40px' } },
                    })}
                >
                    <Crown />
                </Box>
            )}
            {children}
        </Box>
    )
}
